module["exports"] = [
  "+91###-###-####",
  "+91##########",
  "+91-###-#######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/phone_number/formats.js
// module id = 1137
// module chunks = 0